<script context="module">
</script>

<script>
  import { forceEncodingToSystem } from "../util/encodings.js";
  import { createEventDispatcher, getContext, onMount } from "svelte";
  import ErrorText from "./ErrorText.svelte";
  import { encodingToHex } from "bitframes";
  import Button from "./Button.svelte";
  import {
    currentMintData,
    loadHighlight,
    mintButton,
    userState,
  } from "../util/highlight-loader.js";
  import SignInButton from "./SignInButton.svelte";
  import {
    displayEther,
    ETH_PRICE,
    isAfterLaunchStore,
    isBeforeLaunchStore,
    LINK_ABOUT,
    LINK_EDITIONS,
    LINK_TERMS,
    MIN_ETH_PRICE_WITH_FEE_STRING,
    OPEN_COLLECTION_ID,
    PLATFORM_FEE_ETH,
  } from "../util/constants.js";
  import LinkButton from "./LinkButton.svelte";
  import ExternalLink from "./ExternalLink.svelte";
  import ArtworkThumb from "./ArtworkThumb.svelte";
  import Loader from "./Loader.svelte";
  import CountdownButton from "./CountdownButton.svelte";
  import Paragraph from "./Paragraph.svelte";
  import AfterCloseButton from "./AfterCloseButton.svelte";

  const encodingStore = getContext("encoding");

  let curEncoding;
  let curSeedHex;
  let unsubEncoding;
  if (encodingStore) {
    unsubEncoding = encodingStore.subscribe((e) => {
      e = forceEncodingToSystem(e, 0x00);
      curSeedHex = encodingToHex(e);
      curEncoding = e;
      console.log(curEncoding);
    });
  }

  onMount(() => {
    return () => {
      unsubEncoding();
    };
  });
</script>

<div class="mint">
  <Paragraph
    >Although the crowdfund is closed, you can still download your design as a
    high quality print-ready PNG.</Paragraph
  >
  <div class="thumb">
    <ArtworkThumb hd encoding={curEncoding} />
  </div>
  <div class="row">
    <input type="number" min="0" max="4096" step="1" />
  </div>

  <div class="row">
    <Button text="Download PNG"></Button>
  </div>
</div>

<style>
  .mint {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    box-sizing: border-box;
    /* max-width: 500px; */
  }
  .thumb {
    width: calc(min(256px, 100%));
    aspect-ratio: 1;
    /* height: 100%; */
  }
  @media screen and (max-width: 800px) {
    .thumb {
      /* width: 256px; */
      /* height: 256px; */
    }
  }
  @media screen and (max-width: 720px) {
  }
</style>
